<template>
	<span class="g-contact-field-icon" :class="{ 'is-h5': h5 }">
		<i v-if="mbmIcon" class="mbm-iconfont" :class="mbmIcon"></i>
		<component v-else :is="iconComponent" />
	</span>
</template>

<script>
	import {
		BankOutlined,
		EnvironmentOutlined,
		LinkOutlined,
		MailOutlined,
		PhoneOutlined,
		PrinterOutlined,
		QqOutlined,
		WechatOutlined,
		WeiboOutlined,
	} from '@ant-design/icons-vue';
	import { getContactFieldMeta } from '../utils/contactInfo.js';

	const ICON_MAP = {
		PhoneOutlined,
		MailOutlined,
		EnvironmentOutlined,
		LinkOutlined,
		PrinterOutlined,
		WechatOutlined,
		QqOutlined,
		WeiboOutlined,
		BankOutlined,
	};

	const MBM_ICON_MAP = {
		phone: 'mbm-dianhua',
		landline: 'mbm-dianhua1',
		email: 'mbm-youxiang1',
		address: 'mbm-dizhi',
		website: 'mbm-wangzhi',
		fax: 'mbm-chuanzhen',
		qq: 'mbm-qq',
		wechat: 'mbm-weixin1',
		weibo: 'mbm-weibo',
		company: 'mbm-gongsimingcheng',
	};

	export default {
		name: 'GContactFieldIcon',
		components: ICON_MAP,
		props: {
			type: {
				type: String,
				default: 'company',
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			mbmIcon() {
				return MBM_ICON_MAP[this.type] || '';
			},
			iconComponent() {
				const meta = getContactFieldMeta(this.type);
				return ICON_MAP[meta.icon] || BankOutlined;
			},
		},
	};
</script>

<style scoped lang="less">
	.g-contact-field-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: 18px;
		font-size: 16px;
		color: #999;
		line-height: 1;

		.mbm-iconfont {
			font-size: inherit;
			color: inherit;
			line-height: 1;
		}

		:deep(.anticon) {
			font-size: inherit;
			color: inherit;
		}

		&.is-h5 {
			width: 0.36rem;
			font-size: 0.32rem;
		}
	}
</style>
